// Static shop catalog. Imported by the TS frontend, the Express dev server,
// and the Cloudflare Pages Functions. All three runtimes load this as ESM.

export const SLOTS = [
  "character",
  "banner",
  "hat",
  "trail",
  "frame",
  "background",
  "background_night",
  "explosion",
];

export const CATALOG = [
  // characters
  // --- lizards (the classic flapping silhouette) ---
  { id: "char.emerald", slot: "character", name: "Emerald", price: 0,
    render: { kind: "lizard", body: "#4caf50", belly: "#aed581", tail: "#388e3c", legs: "#2e7d32" } },
  { id: "char.coral", slot: "character", name: "Coral", price: 50,
    render: { kind: "lizard", body: "#ff7043", belly: "#ffccbc", tail: "#d84315", legs: "#bf360c" } },
  { id: "char.indigo", slot: "character", name: "Indigo", price: 80,
    render: { kind: "lizard", body: "#5c6bc0", belly: "#c5cae9", tail: "#3949ab", legs: "#283593" } },
  { id: "char.gecko", slot: "character", name: "Gecko", price: 95,
    render: { kind: "lizard", body: "#c8a16e", belly: "#ead7b5", tail: "#a8814f", legs: "#8a6635" } },
  { id: "char.skink", slot: "character", name: "Skink", price: 70,
    render: { kind: "lizard", body: "#1a1a2e", belly: "#ff7043", tail: "#1e3a8a", legs: "#0f0f1f" } },
  { id: "char.iguana", slot: "character", name: "Iguana", price: 110,
    render: { kind: "lizard", body: "#2e7d32", belly: "#c5e1a5", tail: "#ef6c00", legs: "#1b5e20", feature: "spikes" } },
  { id: "char.chameleon", slot: "character", name: "Chameleon", price: 170,
    render: { kind: "lizard", body: "#1abc9c", belly: "#b8ece1", tail: "#8e44ad", legs: "#16846f", feature: "frill" } },
  { id: "char.basilisk", slot: "character", name: "Basilisk", price: 220,
    render: { kind: "lizard", body: "#20bf6b", belly: "#c5f0d2", tail: "#16a085", legs: "#0e7a4f", feature: "crest" } },
  { id: "char.komodo", slot: "character", name: "Komodo", price: 140,
    render: { kind: "lizard", body: "#6e5a4b", belly: "#ad9b87", tail: "#4d3f33", legs: "#382d23", feature: "spikes" } },
  { id: "char.monitor", slot: "character", name: "Monitor", price: 160,
    render: { kind: "lizard", body: "#2c2c2c", belly: "#888888", tail: "#1a1a1a", legs: "#050505" } },

  // --- snakes (no legs, sinuous body) ---
  { id: "char.viper", slot: "character", name: "Viper", price: 100,
    render: { kind: "snake", primary: "#6b8e23", secondary: "#4f6b1a", belly: "#d4cf8a", pattern: "diamond" } },
  { id: "char.cobra", slot: "character", name: "Cobra", price: 120,
    render: { kind: "snake", primary: "#4e342e", secondary: "#e8c46c", belly: "#e8c46c", hood: true } },
  { id: "char.python", slot: "character", name: "Python", price: 150,
    render: { kind: "snake", primary: "#f4e285", secondary: "#8b5a2b", belly: "#f7eccd", pattern: "blotches" } },
  { id: "char.adder", slot: "character", name: "Adder", price: 80,
    render: { kind: "snake", primary: "#6b4226", secondary: "#3a1e0f", belly: "#d8c39e", pattern: "zigzag" } },

  // --- crocodilians (long snout, heavy tail, ridged back) ---
  { id: "char.alligator", slot: "character", name: "Alligator", price: 180,
    render: { kind: "croc", body: "#2f3e1f", belly: "#b3a679", scute: "#1a230f" } },
  { id: "char.caiman", slot: "character", name: "Caiman", price: 110,
    render: { kind: "croc", body: "#4b6043", belly: "#b8a778", scute: "#2c3a25" } },

  // --- turtles (shell + small head + flippers) ---
  { id: "char.tortoise", slot: "character", name: "Tortoise", price: 70,
    render: { kind: "turtle", shell: "#6b4d2b", body: "#c8a878", accent: "#5a7d3d" } },
  { id: "char.terrapin", slot: "character", name: "Terrapin", price: 140,
    render: { kind: "turtle", shell: "#4a5d23", body: "#d4c970", accent: "#2d3c0f" } },

  // --- beetles (round shell, 6 legs) ---
  { id: "char.beetle", slot: "character", name: "Beetle", price: 85,
    render: { kind: "beetle", shell: "#0f3b2e", accent: "#1c5446", legs: "#000a05" } },
  { id: "char.scarab", slot: "character", name: "Scarab", price: 280,
    render: { kind: "beetle", shell: "#1e3a8a", accent: "#ffd54a", legs: "#0d1f4d", horn: true } },
  { id: "char.weevil", slot: "character", name: "Weevil", price: 60,
    render: { kind: "beetle", shell: "#4e342e", accent: "#795548", legs: "#1a0f0a", snout: true } },

  // --- flying insects (body + wings + antennae) ---
  { id: "char.dragonfly", slot: "character", name: "Dragonfly", price: 250,
    render: { kind: "flying_insect", body: "#1a73e8", wing: "#b3d9ff", accent: "#00bcd4", antennaeLong: true } },
  { id: "char.hornet", slot: "character", name: "Hornet", price: 130,
    render: { kind: "flying_insect", body: "#f9a825", wing: "#1a1a1a", accent: "#3e2723", stinger: true } },
  { id: "char.wasp", slot: "character", name: "Wasp", price: 130,
    render: { kind: "flying_insect", body: "#f9a825", wing: "#1a1a1a", accent: "#b71c1c", stinger: true } },
  { id: "char.mantis", slot: "character", name: "Mantis", price: 90,
    render: { kind: "flying_insect", body: "#aed581", wing: "#dcedc8", accent: "#558b2f" } },
  { id: "char.moth", slot: "character", name: "Moth", price: 65,
    render: { kind: "flying_insect", body: "#a1887f", wing: "#d7ccc8", accent: "#5d4037", furry: true } },
  { id: "char.cicada", slot: "character", name: "Cicada", price: 80,
    render: { kind: "flying_insect", body: "#6d4c41", wing: "#d7ccc8", accent: "#3e2723" } },
  { id: "char.firefly", slot: "character", name: "Firefly", price: 300,
    render: { kind: "flying_insect", body: "#1a1a1a", wing: "#fff176", accent: "#050505", glow: true } },
  { id: "char.locust", slot: "character", name: "Locust", price: 75,
    render: { kind: "flying_insect", body: "#afa14a", wing: "#e8d77a", accent: "#8a6b1f" } },

  // --- walking insects (long thin body, 6 legs) ---
  { id: "char.termite", slot: "character", name: "Termite", price: 45,
    render: { kind: "walking_insect", body: "#d7b893", accent: "#8b6b40" } },
  { id: "char.cricket", slot: "character", name: "Cricket", price: 55,
    render: { kind: "walking_insect", body: "#5d4037", accent: "#1a0e08", antennaeLong: true } },
  { id: "char.aphid", slot: "character", name: "Aphid", price: 40,
    render: { kind: "walking_insect", body: "#c5e1a5", accent: "#9ccc65" } },
  { id: "char.earwig", slot: "character", name: "Earwig", price: 50,
    render: { kind: "walking_insect", body: "#4e342e", accent: "#2d1b13", pincers: true } },

  // --- GOD collection ---
  { id: "char.god", slot: "character", name: "God Lizard", price: 999,
    render: { kind: "lizard", body: "#ffd700", belly: "#ffffff", tail: "#f5c518", legs: "#daa520", eyeWhite: "#fff8dc", eyePupil: "#5d4037", feature: "halo" } },

  // --- CREATOR collection (admin-grant only) ---
  // body/belly/tail/legs are placeholders — `rainbow: true` overrides them with
  // a smooth hue cycle at draw time (see CharacterSprite.drawLizardKit).
  { id: "char.creator", slot: "character", name: "Creator Lizard", price: 1500,
    render: { kind: "lizard", body: "#ff0040", belly: "#ffffff", tail: "#7c00ff", legs: "#0080ff", rainbow: true } },

  // --- Monochrome collection (black / gray / white) ---
  { id: "char.mono", slot: "character", name: "Monochrome", price: 400,
    render: { kind: "lizard", body: "#9e9e9e", belly: "#f5f5f5", tail: "#424242", legs: "#1a1a1a", eyeWhite: "#ffffff", eyePupil: "#000000" } },

  // banners
  {
    id: "ban.bronze",
    slot: "banner",
    name: "Bronze",
    price: 30,
    render: { kind: "solid", a: "#cd7f32" },
  },
  {
    id: "ban.sunset",
    slot: "banner",
    name: "Sunset",
    price: 40,
    render: { kind: "gradient", a: "#ff9a76", b: "#ffc371" },
  },
  {
    id: "ban.stripes",
    slot: "banner",
    name: "Stripes",
    price: 60,
    render: { kind: "stripes", a: "#ffd54a", b: "#ff8a65" },
  },
  {
    id: "ban.galaxy",
    slot: "banner",
    name: "Galaxy",
    price: 100,
    render: { kind: "gradient", a: "#1a237e", b: "#7e57c2" },
  },

  // --- solid colors ---
  { id: "ban.olive", slot: "banner", name: "Olive", price: 30,
    render: { kind: "solid", a: "#6b8e23" } },
  { id: "ban.scarlet", slot: "banner", name: "Scarlet", price: 35,
    render: { kind: "solid", a: "#d32f2f" } },
  { id: "ban.amber", slot: "banner", name: "Amber", price: 35,
    render: { kind: "solid", a: "#ffb300" } },
  { id: "ban.lemon", slot: "banner", name: "Lemon", price: 35,
    render: { kind: "solid", a: "#fff44f" } },
  { id: "ban.azure", slot: "banner", name: "Azure", price: 40,
    render: { kind: "solid", a: "#4fc3f7" } },
  { id: "ban.crimson", slot: "banner", name: "Crimson", price: 40,
    render: { kind: "solid", a: "#b71c1c" } },
  { id: "ban.cobalt", slot: "banner", name: "Cobalt", price: 40,
    render: { kind: "solid", a: "#0047ab" } },
  { id: "ban.indigo", slot: "banner", name: "Indigo", price: 45,
    render: { kind: "solid", a: "#303f9f" } },
  { id: "ban.lavender", slot: "banner", name: "Lavender", price: 45,
    render: { kind: "solid", a: "#b39ddb" } },
  { id: "ban.jade", slot: "banner", name: "Jade", price: 60,
    render: { kind: "solid", a: "#00bfa5" } },
  { id: "ban.ruby", slot: "banner", name: "Ruby", price: 70,
    render: { kind: "solid", a: "#c2185b" } },
  { id: "ban.garnet", slot: "banner", name: "Garnet", price: 80,
    render: { kind: "solid", a: "#8b0000" } },
  { id: "ban.terracotta", slot: "banner", name: "Terracotta", price: 90,
    render: { kind: "solid", a: "#d2691e" } },
  { id: "ban.fuchsia", slot: "banner", name: "Fuchsia", price: 100,
    render: { kind: "solid", a: "#ff00ff" } },

  // --- gradients ---
  { id: "ban.emerald", slot: "banner", name: "Emerald", price: 60,
    render: { kind: "gradient", a: "#2e7d32", b: "#66bb6a" } },
  { id: "ban.coral", slot: "banner", name: "Coral", price: 65,
    render: { kind: "gradient", a: "#ff7f50", b: "#ffb09c" } },
  { id: "ban.saffron", slot: "banner", name: "Saffron", price: 70,
    render: { kind: "gradient", a: "#ffd54a", b: "#ff8f00" } },
  { id: "ban.topaz", slot: "banner", name: "Topaz", price: 75,
    render: { kind: "gradient", a: "#ffcc80", b: "#ffa726" } },
  { id: "ban.aquamarine", slot: "banner", name: "Aquamarine", price: 75,
    render: { kind: "gradient", a: "#7fffd4", b: "#80deea" } },
  { id: "ban.turquoise", slot: "banner", name: "Turquoise", price: 80,
    render: { kind: "gradient", a: "#1de9b6", b: "#00bcd4" } },
  { id: "ban.amethyst", slot: "banner", name: "Amethyst", price: 110,
    render: { kind: "gradient", a: "#9c27b0", b: "#ce93d8" } },
  { id: "ban.silver", slot: "banner", name: "Silver", price: 120,
    render: { kind: "gradient", a: "#e0e0e0", b: "#9e9e9e" } },
  { id: "ban.ultramarine", slot: "banner", name: "Ultramarine", price: 130,
    render: { kind: "gradient", a: "#1a237e", b: "#3949ab" } },
  { id: "ban.golden", slot: "banner", name: "Golden", price: 150,
    render: { kind: "gradient", a: "#ffd700", b: "#f9a825" } },
  { id: "ban.neon", slot: "banner", name: "Neon", price: 200,
    render: { kind: "gradient", a: "#ff00ff", b: "#00ffff" } },
  { id: "ban.platinum", slot: "banner", name: "Platinum", price: 220,
    render: { kind: "gradient", a: "#e5e4e2", b: "#cfd8dc" } },
  { id: "ban.opal", slot: "banner", name: "Opal", price: 250,
    render: { kind: "gradient", a: "#d9e3ff", b: "#f3d6ff" } },

  // --- striped ---
  { id: "ban.malachite", slot: "banner", name: "Malachite", price: 130,
    render: { kind: "stripes", a: "#0bda51", b: "#047857" } },

  // --- special / GOD collection ---
  { id: "ban.creator", slot: "banner", name: "CREATOR", price: 1500,
    render: { kind: "lizards", a: "#1a0e2e", b: "#3d1f6b" } },
  { id: "ban.god", slot: "banner", name: "GOD", price: 999,
    render: { kind: "god", a: "#0a0a0a", b: "#ffd700" } },
  { id: "ban.mono", slot: "banner", name: "Monochrome", price: 400,
    render: { kind: "gradient", a: "#1a1a1a", b: "#f5f5f5" } },

  // hats / accessories
  // --- propellers (the originals) ---
  { id: "hat.red", slot: "hat", name: "All Red", price: 25,
    render: { kind: "propeller", wedges: ["#e53935", "#c62828", "#e53935", "#c62828"], blade: "#ffcdd2", hub: "#1a1a1a" } },
  { id: "hat.gold", slot: "hat", name: "Royal Gold", price: 35,
    render: { kind: "propeller", wedges: ["#fbc02d", "#f9a825", "#fbc02d", "#f9a825"], blade: "#fff8e1", hub: "#5d4037" } },
  { id: "hat.rainbow", slot: "hat", name: "Rainbow", price: 70,
    render: { kind: "propeller", wedges: ["#e53935", "#fbc02d", "#43a047", "#1e88e5"], blade: "#ffffff", hub: "#1a1a1a" } },

  // --- headwear ---
  { id: "hat.bandana", slot: "hat", name: "Bandana", price: 25,
    render: { kind: "bandana", primary: "#c62828", secondary: "#ffffff" } },
  { id: "hat.beret", slot: "hat", name: "Beret", price: 30,
    render: { kind: "beret", primary: "#c2185b" } },
  { id: "hat.halo", slot: "hat", name: "Halo", price: 35,
    render: { kind: "halo", primary: "#ffd54a" } },
  { id: "hat.horns", slot: "hat", name: "Horns", price: 40,
    render: { kind: "horns", primary: "#3e2723" } },
  { id: "hat.cat_ears", slot: "hat", name: "Cat-ears", price: 45,
    render: { kind: "cat_ears", primary: "#5d4037", secondary: "#ffb0bf" } },
  { id: "hat.helmet", slot: "hat", name: "Helmet", price: 50,
    render: { kind: "helmet", primary: "#9e9e9e", secondary: "#c62828" } },
  { id: "hat.visor", slot: "hat", name: "Visor", price: 55,
    render: { kind: "visor", primary: "#1e88e5" } },
  { id: "hat.hood", slot: "hat", name: "Hood", price: 60,
    render: { kind: "hood", primary: "#37474f" } },
  { id: "hat.crown", slot: "hat", name: "Crown", price: 80,
    render: { kind: "crown", primary: "#ffd700", secondary: "#e53935" } },
  { id: "hat.fedora", slot: "hat", name: "Fedora", price: 90,
    render: { kind: "fedora", primary: "#212121", secondary: "#5d4037" } },
  { id: "hat.top_hat", slot: "hat", name: "Top-hat", price: 120,
    render: { kind: "top_hat", primary: "#0d0d0d", secondary: "#ffd700" } },

  // --- face accessories ---
  { id: "hat.eyepatch", slot: "hat", name: "Eyepatch", price: 30,
    render: { kind: "eyepatch", primary: "#0d0d0d" } },
  { id: "hat.glasses", slot: "hat", name: "Glasses", price: 45,
    render: { kind: "glasses", primary: "#1a1a1a", secondary: "#222222" } },
  { id: "hat.mask", slot: "hat", name: "Mask", price: 60,
    render: { kind: "mask", primary: "#0d0d0d" } },

  // --- audio ---
  { id: "hat.headphones", slot: "hat", name: "Headphones", price: 70,
    render: { kind: "headphones", primary: "#1a1a1a", secondary: "#c62828" } },

  // --- body / outfit ---
  { id: "hat.scarf", slot: "hat", name: "Scarf", price: 50,
    render: { kind: "scarf", primary: "#c62828" } },
  { id: "hat.belt", slot: "hat", name: "Belt", price: 60,
    render: { kind: "belt", primary: "#3e2723", secondary: "#ffd700" } },
  { id: "hat.gloves", slot: "hat", name: "Gloves", price: 65,
    render: { kind: "gloves", primary: "#5d4037" } },
  { id: "hat.boots", slot: "hat", name: "Boots", price: 70,
    render: { kind: "boots", primary: "#3e2723" } },
  { id: "hat.badge", slot: "hat", name: "Badge", price: 80,
    render: { kind: "badge", primary: "#ffd700", secondary: "#b71c1c" } },
  { id: "hat.tail", slot: "hat", name: "Tail", price: 90,
    render: { kind: "tail", primary: "#ef6c00", secondary: "#ffffff" } },
  { id: "hat.backpack", slot: "hat", name: "Backpack", price: 100,
    render: { kind: "backpack", primary: "#5d4037", secondary: "#3e2723" } },
  { id: "hat.pauldrons", slot: "hat", name: "Pauldrons", price: 110,
    render: { kind: "pauldrons", primary: "#9e9e9e", secondary: "#ffd700" } },
  { id: "hat.cape", slot: "hat", name: "Cape", price: 130,
    render: { kind: "cape", primary: "#8e1a1a", secondary: "#ffd700" } },
  { id: "hat.quiver", slot: "hat", name: "Quiver", price: 140,
    render: { kind: "quiver", primary: "#5d4037", secondary: "#f5f5f5" } },
  { id: "hat.shield", slot: "hat", name: "Shield", price: 150,
    render: { kind: "shield", primary: "#bdbdbd", secondary: "#ffd700" } },

  // --- effects ---
  { id: "hat.aura", slot: "hat", name: "Aura", price: 180,
    render: { kind: "aura", primary: "#4dd0e1" } },
  { id: "hat.wings", slot: "hat", name: "Wings", price: 220,
    render: { kind: "wings", primary: "#fafafa" } },
  { id: "hat.aura_trail", slot: "hat", name: "Aura-trail", price: 250,
    render: { kind: "aura_trail", primary: "#ff80ab" } },

  // --- GOD ---
  { id: "hat.cross", slot: "hat", name: "Cross", price: 999,
    render: { kind: "cross", primary: "#ffd700", secondary: "#ffffff" } },

  // --- CREATOR (admin-grant only) — "CREATOR" word floats above the head in rainbow ---
  { id: "hat.creator", slot: "hat", name: "Creator Tag", price: 1500,
    render: { kind: "creator_text", primary: "#ffffff" } },
  { id: "hat.mono", slot: "hat", name: "Monochrome", price: 400,
    render: { kind: "top_hat", primary: "#0d0d0d", secondary: "#f5f5f5" } },

  // trails
  { id: "trail.mint", slot: "trail", name: "Mint", price: 35,
    render: { kind: "puff", color: "#80cbc4", sizeMin: 1.5, sizeMax: 3, vy: -10, lifeMin: 0.4, lifeMax: 0.7, ratePerSec: 12 } },
  { id: "trail.ember", slot: "trail", name: "Ember", price: 45,
    render: { kind: "puff", color: "#ff7043", sizeMin: 1.5, sizeMax: 3, vy: -20, lifeMin: 0.3, lifeMax: 0.6, ratePerSec: 14 } },
  { id: "trail.bubbles", slot: "trail", name: "Bubbles", price: 55,
    render: { kind: "puff", color: "rgba(180,225,255,0.9)", sizeMin: 1, sizeMax: 2.5, vy: -30, lifeMin: 0.5, lifeMax: 0.9, ratePerSec: 16 } },

  // --- cheap ---
  { id: "trail.smoke", slot: "trail", name: "Smoke", price: 40,
    render: { kind: "smoke", color: "#9e9e9e", sizeMin: 2, sizeMax: 4, vy: -25, lifeMin: 0.6, lifeMax: 1.0, ratePerSec: 10 } },
  { id: "trail.sparkle", slot: "trail", name: "Sparkle", price: 55,
    render: { kind: "sparkle", color: "#fff59d", sizeMin: 2, sizeMax: 3.5, vy: -15, lifeMin: 0.4, lifeMax: 0.7, ratePerSec: 14 } },
  { id: "trail.pixel", slot: "trail", name: "Pixel", price: 60,
    render: { kind: "pixel", color: "#26c6da", sizeMin: 1, sizeMax: 1.5, vy: -8, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 8 } },

  // --- mid ---
  { id: "trail.fire", slot: "trail", name: "Fire", price: 75,
    render: { kind: "fire", color: "#ff5722", color2: "#ffeb3b", sizeMin: 2, sizeMax: 4, vy: -22, lifeMin: 0.3, lifeMax: 0.6, ratePerSec: 18 } },
  { id: "trail.ghost", slot: "trail", name: "Ghost", price: 80,
    render: { kind: "ghost", color: "#eceff1", sizeMin: 3, sizeMax: 5, vy: -8, lifeMin: 0.6, lifeMax: 1.0, ratePerSec: 8 } },
  { id: "trail.star", slot: "trail", name: "Star", price: 85,
    render: { kind: "star", color: "#ffd54a", sizeMin: 2.5, sizeMax: 4, vy: -12, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 10 } },
  { id: "trail.confetti", slot: "trail", name: "Confetti", price: 90,
    render: { kind: "confetti", color: "#e53935", color2: "#1e88e5", sizeMin: 2, sizeMax: 3.5, vy: -5, lifeMin: 0.6, lifeMax: 1.0, ratePerSec: 16 } },
  { id: "trail.heart", slot: "trail", name: "Heart", price: 95,
    render: { kind: "heart", color: "#ec407a", sizeMin: 2.5, sizeMax: 4, vy: -14, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 9 } },
  { id: "trail.candy", slot: "trail", name: "Candy", price: 100,
    render: { kind: "candy", color: "#f48fb1", color2: "#80deea", sizeMin: 2.5, sizeMax: 4, vy: -10, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 10 } },
  { id: "trail.vapor", slot: "trail", name: "Vapor", price: 105,
    render: { kind: "vapor", color: "#ce93d8", color2: "#80deea", sizeMin: 3, sizeMax: 5, vy: -18, lifeMin: 0.6, lifeMax: 0.9, ratePerSec: 10 } },
  { id: "trail.flame", slot: "trail", name: "Flame", price: 110,
    render: { kind: "fire", color: "#26c6da", color2: "#ffffff", sizeMin: 2, sizeMax: 4, vy: -22, lifeMin: 0.3, lifeMax: 0.6, ratePerSec: 18 } },
  { id: "trail.blossom", slot: "trail", name: "Blossom", price: 120,
    render: { kind: "blossom", color: "#f8bbd0", color2: "#fff3e0", sizeMin: 2.5, sizeMax: 4, vy: -6, lifeMin: 0.7, lifeMax: 1.1, ratePerSec: 8 } },

  // --- premium ---
  { id: "trail.neon", slot: "trail", name: "Neon", price: 130,
    render: { kind: "neon", color: "#00e5ff", sizeMin: 3, sizeMax: 5, vy: -12, lifeMin: 0.4, lifeMax: 0.7, ratePerSec: 10 } },
  { id: "trail.lightning", slot: "trail", name: "Lightning", price: 140,
    render: { kind: "lightning", color: "#ffeb3b", sizeMin: 4, sizeMax: 6, vy: -5, lifeMin: 0.15, lifeMax: 0.3, ratePerSec: 12 } },
  { id: "trail.plasma", slot: "trail", name: "Plasma", price: 145,
    render: { kind: "plasma", color: "#e040fb", color2: "#40c4ff", sizeMin: 3, sizeMax: 5, vy: -10, lifeMin: 0.4, lifeMax: 0.7, ratePerSec: 12 } },
  { id: "trail.cosmic", slot: "trail", name: "Cosmic", price: 150,
    render: { kind: "cosmic", color: "#9575cd", color2: "#ffffff", sizeMin: 2, sizeMax: 3, vy: -10, lifeMin: 0.6, lifeMax: 0.9, ratePerSec: 12 } },
  { id: "trail.magic", slot: "trail", name: "Magic", price: 155,
    render: { kind: "magic", color: "#ce93d8", color2: "#ffd54a", sizeMin: 2.5, sizeMax: 4, vy: -10, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 12 } },
  { id: "trail.cyber", slot: "trail", name: "Cyber", price: 160,
    render: { kind: "cyber", color: "#00ff7f", sizeMin: 1.5, sizeMax: 2.5, vy: -8, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 14 } },
  { id: "trail.crystal", slot: "trail", name: "Crystal", price: 170,
    render: { kind: "crystal", color: "#b3e5fc", color2: "#0288d1", sizeMin: 2.5, sizeMax: 4, vy: -12, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 9 } },
  { id: "trail.laser", slot: "trail", name: "Laser", price: 175,
    render: { kind: "laser", color: "#ef5350", sizeMin: 5, sizeMax: 7, vy: 0, lifeMin: 0.2, lifeMax: 0.4, ratePerSec: 18 } },
  { id: "trail.shadow", slot: "trail", name: "Shadow", price: 180,
    render: { kind: "shadow", color: "#212121", sizeMin: 3, sizeMax: 5, vy: -6, lifeMin: 0.5, lifeMax: 0.9, ratePerSec: 10 } },
  { id: "trail.gold", slot: "trail", name: "Gold", price: 200,
    render: { kind: "gold", color: "#ffd700", color2: "#fff176", sizeMin: 2.5, sizeMax: 4, vy: -14, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 12 } },

  // --- rare ---
  { id: "trail.bubble", slot: "trail", name: "Bubble", price: 130,
    render: { kind: "bubble", color: "#b3e5fc", sizeMin: 2.5, sizeMax: 5, vy: -25, lifeMin: 0.7, lifeMax: 1.1, ratePerSec: 8 } },
  { id: "trail.aurora", slot: "trail", name: "Aurora", price: 230,
    render: { kind: "aurora", color: "#69f0ae", color2: "#b388ff", sizeMin: 4, sizeMax: 6, vy: -8, lifeMin: 0.7, lifeMax: 1.1, ratePerSec: 8 } },
  { id: "trail.portal", slot: "trail", name: "Portal", price: 240,
    render: { kind: "portal", color: "#7c4dff", color2: "#00bcd4", sizeMin: 3, sizeMax: 5, vy: 0, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 14 } },
  { id: "trail.void", slot: "trail", name: "Void", price: 250,
    render: { kind: "void", color: "#1a1a2e", color2: "#7c4dff", sizeMin: 3, sizeMax: 5, vy: -8, lifeMin: 0.5, lifeMax: 0.9, ratePerSec: 10 } },
  { id: "trail.glitch", slot: "trail", name: "Glitch", price: 260,
    render: { kind: "glitch", color: "#ff0080", color2: "#00ffea", sizeMin: 2, sizeMax: 4, vy: -8, lifeMin: 0.3, lifeMax: 0.6, ratePerSec: 14 } },
  { id: "trail.blizzard", slot: "trail", name: "Blizzard", price: 280,
    render: { kind: "blizzard", color: "#ffffff", sizeMin: 2, sizeMax: 4, vy: -5, lifeMin: 0.6, lifeMax: 1.0, ratePerSec: 18 } },

  // --- GOD ---
  { id: "trail.divine", slot: "trail", name: "Divine", price: 999,
    render: { kind: "divine", color: "#ffd700", color2: "#ffffff", sizeMin: 2, sizeMax: 4, vy: -22, lifeMin: 0.6, lifeMax: 1.0, ratePerSec: 14 } },

  // --- CREATOR (admin-grant only) — thick, solid rainbow band trailing behind ---
  { id: "trail.creator", slot: "trail", name: "Creator Trail", price: 1500,
    render: { kind: "creator", color: "#ffffff", sizeMin: 4.5, sizeMax: 5.5, vy: 0, lifeMin: 0.9, lifeMax: 1.0, ratePerSec: 34 } },
  { id: "trail.mono", slot: "trail", name: "Monochrome", price: 400,
    render: { kind: "smoke", color: "#bdbdbd", sizeMin: 2, sizeMax: 4, vy: -18, lifeMin: 0.5, lifeMax: 0.9, ratePerSec: 14 } },

  // frames
  // --- cheap ---
  { id: "frame.bronze", slot: "frame", name: "Bronze", price: 20,
    render: { kind: "bronze", color: "#cd7f32", color2: "#f5d0a0", width: 3 } },
  { id: "frame.silver", slot: "frame", name: "Silver", price: 30,
    render: { kind: "silver", color: "#c0c0c0", color2: "#f5f5f5", width: 3 } },
  { id: "frame.pixel", slot: "frame", name: "Pixel", price: 35,
    render: { kind: "pixel", color: "#26c6da", width: 3 } },
  { id: "frame.vintage", slot: "frame", name: "Vintage", price: 40,
    render: { kind: "vintage", color: "#8d6e63", color2: "#fff3e0", width: 2 } },
  { id: "frame.ancient", slot: "frame", name: "Ancient", price: 45,
    render: { kind: "ancient", color: "#a1887f", color2: "#3e2723", width: 3 } },

  // --- mid ---
  { id: "frame.gold", slot: "frame", name: "Gold", price: 60,
    render: { kind: "gold", color: "#ffd700", color2: "#fff8a0", width: 3 } },
  { id: "frame.cyber", slot: "frame", name: "Cyber", price: 65,
    render: { kind: "cyber", color: "#00ff7f", color2: "#004d00", width: 3 } },
  { id: "frame.shadow", slot: "frame", name: "Shadow", price: 70,
    render: { kind: "shadow", color: "#212121", color2: "#7c4dff", width: 4 } },
  { id: "frame.bubble", slot: "frame", name: "Bubble", price: 75,
    render: { kind: "bubble", color: "#80deea", color2: "#ffffff", width: 2 } },
  { id: "frame.steampunk", slot: "frame", name: "Steampunk", price: 90,
    render: { kind: "steampunk", color: "#8d6e63", color2: "#cd7f32", width: 3 } },

  // --- high ---
  { id: "frame.platinum", slot: "frame", name: "Platinum", price: 110,
    render: { kind: "platinum", color: "#e5e4e2", color2: "#cfd8dc", width: 3 } },
  { id: "frame.diamond", slot: "frame", name: "Diamond", price: 120,
    render: { kind: "diamond", color: "#b3e5fc", color2: "#ffffff", width: 3 } },
  { id: "frame.ruby", slot: "frame", name: "Ruby", price: 130,
    render: { kind: "ruby", color: "#c2185b", color2: "#ff80ab", width: 3 } },
  { id: "frame.emerald", slot: "frame", name: "Emerald", price: 130,
    render: { kind: "emerald", color: "#2e7d32", color2: "#a5d6a7", width: 3 } },
  { id: "frame.sapphire", slot: "frame", name: "Sapphire", price: 130,
    render: { kind: "sapphire", color: "#1a237e", color2: "#7986cb", width: 3 } },
  { id: "frame.crystal", slot: "frame", name: "Crystal", price: 140,
    render: { kind: "crystal", color: "#b2ebf2", color2: "#80deea", width: 3 } },
  { id: "frame.royal", slot: "frame", name: "Royal", price: 150,
    render: { kind: "royal", color: "#6a1b9a", color2: "#ffd700", width: 3 } },
  { id: "frame.sakura", slot: "frame", name: "Sakura", price: 160,
    render: { kind: "sakura", color: "#f48fb1", color2: "#fff0f5", width: 2 } },
  { id: "frame.golden_leaf", slot: "frame", name: "Golden-leaf", price: 170,
    render: { kind: "golden_leaf", color: "#ffd700", color2: "#8d6e63", width: 3 } },
  { id: "frame.frozen", slot: "frame", name: "Frozen", price: 175,
    render: { kind: "frozen", color: "#b3e5fc", color2: "#ffffff", width: 3 } },
  { id: "frame.flame", slot: "frame", name: "Flame", price: 180,
    render: { kind: "flame", color: "#ff5722", color2: "#ffeb3b", width: 3 } },

  // --- premium ---
  { id: "frame.lava", slot: "frame", name: "Lava", price: 190,
    render: { kind: "lava", color: "#e65100", color2: "#ffeb3b", width: 4 } },
  { id: "frame.thorn", slot: "frame", name: "Thorn", price: 200,
    render: { kind: "thorn", color: "#1b5e20", color2: "#33691e", width: 3 } },
  { id: "frame.cosmic", slot: "frame", name: "Cosmic", price: 210,
    render: { kind: "cosmic", color: "#1a237e", color2: "#fff176", width: 3 } },
  { id: "frame.obsidian", slot: "frame", name: "Obsidian", price: 230,
    render: { kind: "obsidian", color: "#0d0d0d", color2: "#7c4dff", width: 3 } },
  { id: "frame.gothic", slot: "frame", name: "Gothic", price: 240,
    render: { kind: "gothic", color: "#1a1a1a", color2: "#880e4f", width: 4 } },
  { id: "frame.rainbow", slot: "frame", name: "Rainbow", price: 260,
    render: { kind: "rainbow", color: "#ffffff", width: 3 } },
  { id: "frame.neon", slot: "frame", name: "Neon", price: 270,
    render: { kind: "neon", color: "#00e676", color2: "#76ff03", width: 3 } },
  { id: "frame.holographic", slot: "frame", name: "Holographic", price: 300,
    render: { kind: "holographic", color: "#ffffff", width: 3 } },

  // --- GOD ---
  { id: "frame.gates_of_heaven", slot: "frame", name: "Gates of Heaven", price: 999,
    render: { kind: "gates_of_heaven", color: "#ffd700", color2: "#ffffff", width: 3 } },

  // --- CREATOR (admin-grant only) — rainbow border with "CREATOR" repeated around it ---
  { id: "frame.creator", slot: "frame", name: "Creator Frame", price: 1500,
    render: { kind: "creator", color: "#ffffff", color2: "#ffffff", width: 4 } },
  { id: "frame.mono", slot: "frame", name: "Monochrome", price: 400,
    render: { kind: "neon", color: "#bdbdbd", color2: "#ffffff", width: 3 } },

  // backgrounds — full sky/scenery palettes. You equip one DAY scenery and one
  // NIGHT scenery; play transitions from your day into your night as the score
  // climbs past NIGHT_THRESHOLD. The menu always shows the day scenery.

  // --- day scenery (slot "background") ---
  { id: "bg.meadow", slot: "background", name: "Meadow", price: 60,
    render: { kind: "sky", skyTop: "#7ed0ff", skyBottom: "#cdeec8", treeFar: "#3f7a3a", treeNear: "#1f5a2c", cloud: "rgba(255,255,255,0.85)", sun: "#ffe27a", isNight: false } },
  { id: "bg.sunset", slot: "background", name: "Sunset", price: 90,
    render: { kind: "sky", skyTop: "#ff8a5c", skyBottom: "#ffd9a0", treeFar: "#6b3f5a", treeNear: "#3f1f38", cloud: "rgba(255,225,200,0.8)", sun: "#fff0c0", isNight: false } },
  { id: "bg.desert", slot: "background", name: "Desert", price: 90,
    render: { kind: "sky", skyTop: "#fbd9a0", skyBottom: "#f7efce", treeFar: "#caa86a", treeNear: "#a8814f", cloud: "rgba(255,255,255,0.7)", sun: "#ffe27a", isNight: false } },
  { id: "bg.noir", slot: "background", name: "Noir", price: 110,
    render: { kind: "sky", skyTop: "#2a2a2a", skyBottom: "#707070", treeFar: "#161616", treeNear: "#070707", cloud: "rgba(255,255,255,0.30)", sun: "#d0d0d0", isNight: false } },
  { id: "bg.sakura", slot: "background", name: "Sakura", price: 130,
    render: { kind: "sky", skyTop: "#ffd1e8", skyBottom: "#fff0f5", treeFar: "#e89ab8", treeNear: "#d46a8e", cloud: "rgba(255,255,255,0.85)", sun: "#fff4fa", isNight: false } },
  { id: "bg.candy", slot: "background", name: "Candy", price: 140,
    render: { kind: "sky", skyTop: "#c5a3ff", skyBottom: "#ffd1f0", treeFar: "#a06ad4", treeNear: "#7c4dff", cloud: "rgba(255,255,255,0.85)", sun: "#fff176", isNight: false } },
  { id: "bg.azure", slot: "background", name: "Clear Sky", price: 70,
    render: { kind: "sky", skyTop: "#4fb8ff", skyBottom: "#b8e8ff", treeFar: "#2e7d5a", treeNear: "#1b5e3a", cloud: "rgba(255,255,255,0.9)", sun: "#fff6c0", isNight: false } },
  { id: "bg.dawn", slot: "background", name: "Dawn", price: 100,
    render: { kind: "sky", skyTop: "#ffb27a", skyBottom: "#ffe6c0", treeFar: "#7a5a6b", treeNear: "#4a3340", cloud: "rgba(255,235,215,0.8)", sun: "#fff2d0", isNight: false } },
  { id: "bg.autumn", slot: "background", name: "Autumn", price: 120,
    render: { kind: "sky", skyTop: "#ff9e5c", skyBottom: "#ffd9a8", treeFar: "#b25a2a", treeNear: "#7a3a18", cloud: "rgba(255,240,220,0.8)", sun: "#ffd27a", isNight: false } },
  { id: "bg.spring", slot: "background", name: "Spring", price: 80,
    render: { kind: "sky", skyTop: "#aee6ff", skyBottom: "#e8ffd9", treeFar: "#6db84a", treeNear: "#3f8a2c", cloud: "rgba(255,255,255,0.9)", sun: "#fff39a", isNight: false } },
  { id: "bg.tropical", slot: "background", name: "Tropical", price: 150,
    render: { kind: "sky", skyTop: "#35d0e0", skyBottom: "#c0f5e8", treeFar: "#1aa07a", treeNear: "#0d6e52", cloud: "rgba(255,255,255,0.85)", sun: "#fff0a0", isNight: false } },
  { id: "bg.savanna", slot: "background", name: "Savanna", price: 100,
    render: { kind: "sky", skyTop: "#f5c969", skyBottom: "#f7e6a8", treeFar: "#b89a4a", treeNear: "#8a6f2a", cloud: "rgba(255,255,255,0.75)", sun: "#ffe27a", isNight: false } },
  { id: "bg.lavender", slot: "background", name: "Lavender", price: 130,
    render: { kind: "sky", skyTop: "#c9b6f0", skyBottom: "#efe6ff", treeFar: "#8a6db8", treeNear: "#5e4a8a", cloud: "rgba(255,255,255,0.85)", sun: "#fff4d0", isNight: false } },
  { id: "bg.mint", slot: "background", name: "Mint", price: 110,
    render: { kind: "sky", skyTop: "#a8ecdf", skyBottom: "#e0fff7", treeFar: "#3fae8e", treeNear: "#27806a", cloud: "rgba(255,255,255,0.85)", sun: "#f0ffd0", isNight: false } },
  { id: "bg.peach", slot: "background", name: "Peach", price: 110,
    render: { kind: "sky", skyTop: "#ffc6a8", skyBottom: "#ffe9da", treeFar: "#c98a6a", treeNear: "#9a5e42", cloud: "rgba(255,245,238,0.85)", sun: "#fff0d0", isNight: false } },
  { id: "bg.emerald_day", slot: "background", name: "Emerald", price: 150,
    render: { kind: "sky", skyTop: "#6fe0a0", skyBottom: "#d0ffe0", treeFar: "#1f8a4a", treeNear: "#0e6030", cloud: "rgba(255,255,255,0.85)", sun: "#fff39a", isNight: false } },
  { id: "bg.golden", slot: "background", name: "Golden Hour", price: 160,
    render: { kind: "sky", skyTop: "#ffb84a", skyBottom: "#ffe39a", treeFar: "#a8742a", treeNear: "#6e4a18", cloud: "rgba(255,240,210,0.8)", sun: "#fff0b0", isNight: false } },
  { id: "bg.overcast", slot: "background", name: "Overcast", price: 70,
    render: { kind: "sky", skyTop: "#9aa6b0", skyBottom: "#cdd6dd", treeFar: "#4a5a55", treeNear: "#2e3a36", cloud: "rgba(255,255,255,0.4)", sun: "#e8eef0", isNight: false } },
  { id: "bg.cotton", slot: "background", name: "Cotton Candy", price: 140,
    render: { kind: "sky", skyTop: "#a8d8ff", skyBottom: "#ffd6ec", treeFar: "#9a8ad0", treeNear: "#6e5aa8", cloud: "rgba(255,255,255,0.9)", sun: "#fff4d0", isNight: false } },
  { id: "bg.coral_day", slot: "background", name: "Coral Reef", price: 150,
    render: { kind: "sky", skyTop: "#5ad6e0", skyBottom: "#c0f0f5", treeFar: "#e0805a", treeNear: "#b2503a", cloud: "rgba(255,255,255,0.85)", sun: "#fff0c0", isNight: false } },
  { id: "bg.sunflower", slot: "background", name: "Sunflower", price: 120,
    render: { kind: "sky", skyTop: "#7ec8ff", skyBottom: "#e8f5b0", treeFar: "#c9a82a", treeNear: "#8a6f14", cloud: "rgba(255,255,255,0.85)", sun: "#ffe24a", isNight: false } },
  { id: "bg.arctic_day", slot: "background", name: "Arctic", price: 130,
    render: { kind: "sky", skyTop: "#bfe8ff", skyBottom: "#eaf6ff", treeFar: "#8aa6b8", treeNear: "#5e7a8a", cloud: "rgba(255,255,255,0.9)", sun: "#f0faff", isNight: false } },
  { id: "bg.jungle", slot: "background", name: "Jungle", price: 150,
    render: { kind: "sky", skyTop: "#6fc8a0", skyBottom: "#c0f0d0", treeFar: "#175a32", treeNear: "#0a3a1e", cloud: "rgba(255,255,255,0.7)", sun: "#fff39a", isNight: false } },
  { id: "bg.pastel", slot: "background", name: "Pastel", price: 120,
    render: { kind: "sky", skyTop: "#cfe8ff", skyBottom: "#ffe8f0", treeFar: "#b0a0d0", treeNear: "#8070a8", cloud: "rgba(255,255,255,0.9)", sun: "#fff4d0", isNight: false } },
  { id: "bg.ocean_day", slot: "background", name: "Ocean Day", price: 140,
    render: { kind: "sky", skyTop: "#4fc8ff", skyBottom: "#a8e8f0", treeFar: "#2a7a8a", treeNear: "#154a5a", cloud: "rgba(255,255,255,0.85)", sun: "#fff0c0", isNight: false } },

  // --- night scenery (slot "background_night") ---
  { id: "bg.forest_night", slot: "background_night", name: "Forest Night", price: 60,
    render: { kind: "sky", skyTop: "#0e1a3a", skyBottom: "#23365a", treeFar: "#1a3324", treeNear: "#0c1e15", cloud: "rgba(220,220,255,0.35)", sun: "#e8eef7", isNight: true } },
  { id: "bg.midnight", slot: "background_night", name: "Midnight", price: 120,
    render: { kind: "sky", skyTop: "#0a0e24", skyBottom: "#1f2c4d", treeFar: "#13202e", treeNear: "#0a121c", cloud: "rgba(200,210,255,0.30)", sun: "#e8eef7", isNight: true } },
  { id: "bg.bloodmoon", slot: "background_night", name: "Blood Moon", price: 150,
    render: { kind: "sky", skyTop: "#2a0a14", skyBottom: "#5a1020", treeFar: "#1a0810", treeNear: "#0d0408", cloud: "rgba(255,120,140,0.30)", sun: "#ff5a6a", isNight: true } },
  { id: "bg.volcano", slot: "background_night", name: "Volcano", price: 160,
    render: { kind: "sky", skyTop: "#360909", skyBottom: "#7a1d0a", treeFar: "#2a0c08", treeNear: "#160504", cloud: "rgba(255,120,60,0.40)", sun: "#ff7043", isNight: true } },
  { id: "bg.aurora", slot: "background_night", name: "Aurora", price: 170,
    render: { kind: "sky", skyTop: "#0c2440", skyBottom: "#1f6f7a", treeFar: "#0e3a40", treeNear: "#072830", cloud: "rgba(160,255,225,0.40)", sun: "#a0ffe0", isNight: true } },
  { id: "bg.starry", slot: "background_night", name: "Starry", price: 90,
    render: { kind: "sky", skyTop: "#070a20", skyBottom: "#14224a", treeFar: "#0e1830", treeNear: "#070c18", cloud: "rgba(220,225,255,0.35)", sun: "#eef2ff", isNight: true } },
  { id: "bg.eclipse", slot: "background_night", name: "Eclipse", price: 200,
    render: { kind: "sky", skyTop: "#100408", skyBottom: "#2a0a10", treeFar: "#0a0306", treeNear: "#040102", cloud: "rgba(255,180,120,0.25)", sun: "#ff8a3a", isNight: true } },
  { id: "bg.nebula", slot: "background_night", name: "Nebula", price: 190,
    render: { kind: "sky", skyTop: "#1a0a3a", skyBottom: "#4a1a6a", treeFar: "#2a1240", treeNear: "#160826", cloud: "rgba(220,180,255,0.35)", sun: "#e0b8ff", isNight: true } },
  { id: "bg.moonlit", slot: "background_night", name: "Moonlit", price: 110,
    render: { kind: "sky", skyTop: "#12203f", skyBottom: "#2a3f63", treeFar: "#1a2c40", treeNear: "#0e1a28", cloud: "rgba(220,225,255,0.40)", sun: "#f5f8ff", isNight: true } },
  { id: "bg.crimson_night", slot: "background_night", name: "Crimson Night", price: 140,
    render: { kind: "sky", skyTop: "#2a0610", skyBottom: "#56101e", treeFar: "#1c0810", treeNear: "#0e040a", cloud: "rgba(255,120,140,0.3)", sun: "#ff6a7a", isNight: true } },
  { id: "bg.emerald_night", slot: "background_night", name: "Emerald Night", price: 150,
    render: { kind: "sky", skyTop: "#06241a", skyBottom: "#0e4a36", treeFar: "#0a3326", treeNear: "#051a14", cloud: "rgba(180,255,220,0.30)", sun: "#a8ffd8", isNight: true } },
  { id: "bg.cyber_night", slot: "background_night", name: "Cyber Night", price: 180,
    render: { kind: "sky", skyTop: "#0a0a1e", skyBottom: "#14143a", treeFar: "#0e1a2e", treeNear: "#070d18", cloud: "rgba(120,255,240,0.30)", sun: "#50f0e0", isNight: true } },
  { id: "bg.haunted", slot: "background_night", name: "Haunted", price: 130,
    render: { kind: "sky", skyTop: "#14121e", skyBottom: "#2a2438", treeFar: "#161420", treeNear: "#0c0a12", cloud: "rgba(200,210,255,0.25)", sun: "#c8b8e8", isNight: true } },
  { id: "bg.deep_sea", slot: "background_night", name: "Deep Sea", price: 150,
    render: { kind: "sky", skyTop: "#041a26", skyBottom: "#0a3a4a", treeFar: "#06283a", treeNear: "#03141e", cloud: "rgba(160,220,255,0.30)", sun: "#a0e0ff", isNight: true } },
  { id: "bg.galaxy", slot: "background_night", name: "Galaxy", price: 200,
    render: { kind: "sky", skyTop: "#0a0826", skyBottom: "#261a5a", treeFar: "#140e3a", treeNear: "#0a0820", cloud: "rgba(220,200,255,0.35)", sun: "#d0c0ff", isNight: true } },
  { id: "bg.obsidian_night", slot: "background_night", name: "Obsidian", price: 140,
    render: { kind: "sky", skyTop: "#0a0a0e", skyBottom: "#1a1a24", treeFar: "#0c0c12", treeNear: "#050508", cloud: "rgba(160,140,255,0.25)", sun: "#8a6ad0", isNight: true } },
  { id: "bg.twilight", slot: "background_night", name: "Twilight", price: 120,
    render: { kind: "sky", skyTop: "#1a1240", skyBottom: "#3a2a6a", treeFar: "#241a4a", treeNear: "#120c28", cloud: "rgba(220,210,255,0.35)", sun: "#e0d0ff", isNight: true } },
  { id: "bg.frost_night", slot: "background_night", name: "Frost Night", price: 150,
    render: { kind: "sky", skyTop: "#0a1a30", skyBottom: "#1f3a5a", treeFar: "#14304a", treeNear: "#0a1a2a", cloud: "rgba(200,235,255,0.35)", sun: "#c8eaff", isNight: true } },
  { id: "bg.ember_night", slot: "background_night", name: "Ember Night", price: 160,
    render: { kind: "sky", skyTop: "#1a0a04", skyBottom: "#3a160a", treeFar: "#200c06", treeNear: "#100603", cloud: "rgba(255,160,90,0.30)", sun: "#ff9a4a", isNight: true } },
  { id: "bg.violet_night", slot: "background_night", name: "Violet Night", price: 140,
    render: { kind: "sky", skyTop: "#14082a", skyBottom: "#32145a", treeFar: "#1e0e40", treeNear: "#100822", cloud: "rgba(220,180,255,0.30)", sun: "#d8a8ff", isNight: true } },
  { id: "bg.abyss", slot: "background_night", name: "Abyss", price: 170,
    render: { kind: "sky", skyTop: "#02060e", skyBottom: "#0a1426", treeFar: "#06101c", treeNear: "#03080e", cloud: "rgba(140,170,220,0.25)", sun: "#a0c0e8", isNight: true } },
  { id: "bg.shadow_night", slot: "background_night", name: "Shadow", price: 130,
    render: { kind: "sky", skyTop: "#121214", skyBottom: "#2a2a2e", treeFar: "#161618", treeNear: "#0a0a0c", cloud: "rgba(200,200,210,0.25)", sun: "#c0c0c8", isNight: true } },
  { id: "bg.neon_night", slot: "background_night", name: "Neon Night", price: 190,
    render: { kind: "sky", skyTop: "#0c0414", skyBottom: "#28063a", treeFar: "#14081e", treeNear: "#0a0410", cloud: "rgba(255,120,240,0.30)", sun: "#ff5af0", isNight: true } },
  { id: "bg.comet", slot: "background_night", name: "Comet", price: 180,
    render: { kind: "sky", skyTop: "#080e26", skyBottom: "#16224a", treeFar: "#0e1830", treeNear: "#080c18", cloud: "rgba(200,225,255,0.40)", sun: "#eaf2ff", isNight: true } },
  { id: "bg.stormy_night", slot: "background_night", name: "Stormy Night", price: 130,
    render: { kind: "sky", skyTop: "#12141a", skyBottom: "#2a2e38", treeFar: "#161a20", treeNear: "#0c0e12", cloud: "rgba(200,210,225,0.3)", sun: "#b0bcc8", isNight: true } },

  // --- collection skies ---
  // GOD (purchasable): divine gold day + dark gilded night.
  { id: "bg.god_day", slot: "background", name: "Heaven", price: 999,
    render: { kind: "sky", skyTop: "#fff3b0", skyBottom: "#ffffff", treeFar: "#d4af37", treeNear: "#a8862a", cloud: "rgba(255,255,255,0.9)", sun: "#fff8a0", isNight: false } },
  { id: "bg.god_night", slot: "background_night", name: "Empyrean", price: 999,
    render: { kind: "sky", skyTop: "#161205", skyBottom: "#3a2e0a", treeFar: "#5a4a14", treeNear: "#2a2008", cloud: "rgba(255,240,180,0.30)", sun: "#ffd700", isNight: true } },
  // CREATOR (admin-grant only): `rainbow` makes the sky cycle the hue wheel.
  { id: "bg.creator_day", slot: "background", name: "Creator Sky", price: 1500,
    render: { kind: "sky", rainbow: true, skyTop: "#ff0040", skyBottom: "#00d0ff", treeFar: "#7c00ff", treeNear: "#3a006a", cloud: "rgba(255,255,255,0.6)", sun: "#ffffff", isNight: false } },
  { id: "bg.creator_night", slot: "background_night", name: "Creator Night", price: 1500,
    render: { kind: "sky", rainbow: true, skyTop: "#2a0040", skyBottom: "#001a40", treeFar: "#3a006a", treeNear: "#0a0020", cloud: "rgba(255,255,255,0.3)", sun: "#ffffff", isNight: true } },
  // Monochrome (purchasable): black / gray / white.
  { id: "bg.mono_day", slot: "background", name: "Monochrome Day", price: 400,
    render: { kind: "sky", skyTop: "#d6d6d6", skyBottom: "#f5f5f5", treeFar: "#707070", treeNear: "#2a2a2a", cloud: "rgba(255,255,255,0.85)", sun: "#ffffff", isNight: false } },
  { id: "bg.mono_night", slot: "background_night", name: "Monochrome Night", price: 400,
    render: { kind: "sky", skyTop: "#0a0a0a", skyBottom: "#3a3a3a", treeFar: "#1a1a1a", treeNear: "#000000", cloud: "rgba(255,255,255,0.25)", sun: "#e0e0e0", isNight: true } },

  // death explosions — a burst played at the lizard when it dies (slot "explosion")
  { id: "exp.poof", slot: "explosion", name: "Poof", price: 40,
    render: { kind: "burst", color: "#f0e0a8" } },
  { id: "exp.smoke", slot: "explosion", name: "Smoke", price: 45,
    render: { kind: "smoke", color: "#9e9e9e" } },
  { id: "exp.pixel", slot: "explosion", name: "Pixel", price: 50,
    render: { kind: "pixel", color: "#26c6da" } },
  { id: "exp.ring", slot: "explosion", name: "Ring", price: 55,
    render: { kind: "ring", color: "#4fc3f7" } },
  { id: "exp.ember", slot: "explosion", name: "Ember", price: 60,
    render: { kind: "fireball", color: "#ff7043", color2: "#ffeb3b" } },
  { id: "exp.bubble", slot: "explosion", name: "Bubble", price: 65,
    render: { kind: "bubble", color: "#b3e5fc" } },
  { id: "exp.sparkle", slot: "explosion", name: "Sparkle", price: 70,
    render: { kind: "sparkle", color: "#fff59d" } },
  { id: "exp.snow", slot: "explosion", name: "Blizzard", price: 80,
    render: { kind: "snow", color: "#ffffff" } },
  { id: "exp.star", slot: "explosion", name: "Starburst", price: 85,
    render: { kind: "starburst", color: "#ffd54a" } },
  { id: "exp.shock", slot: "explosion", name: "Shockwave", price: 90,
    render: { kind: "shockwave", color: "#ffffff" } },
  { id: "exp.confetti", slot: "explosion", name: "Confetti", price: 95,
    render: { kind: "confetti", color: "#e53935", color2: "#1e88e5" } },
  { id: "exp.heart", slot: "explosion", name: "Hearts", price: 95,
    render: { kind: "heart", color: "#ec407a" } },
  { id: "exp.petals", slot: "explosion", name: "Blossom", price: 100,
    render: { kind: "petals", color: "#f8bbd0", color2: "#fff3e0" } },
  { id: "exp.shatter", slot: "explosion", name: "Shatter", price: 105,
    render: { kind: "shatter", color: "#b0bec5", color2: "#eceff1" } },
  { id: "exp.fireball", slot: "explosion", name: "Fireball", price: 110,
    render: { kind: "fireball", color: "#ff5722", color2: "#ffc107" } },
  { id: "exp.firework", slot: "explosion", name: "Firework", price: 120,
    render: { kind: "firework", color: "#e53935", color2: "#ffd54a" } },
  { id: "exp.implode", slot: "explosion", name: "Implosion", price: 130,
    render: { kind: "implode", color: "#7c4dff" } },
  { id: "exp.comet", slot: "explosion", name: "Comet", price: 135,
    render: { kind: "comet", color: "#80d8ff", color2: "#ffffff" } },
  { id: "exp.electric", slot: "explosion", name: "Electric", price: 140,
    render: { kind: "electric", color: "#ffeb3b" } },
  { id: "exp.spiral", slot: "explosion", name: "Spiral", price: 145,
    render: { kind: "spiral", color: "#e040fb", color2: "#40c4ff" } },
  { id: "exp.nova", slot: "explosion", name: "Nova", price: 150,
    render: { kind: "nova", color: "#ff8a65", color2: "#ffffff" } },
  { id: "exp.plasma", slot: "explosion", name: "Plasma", price: 155,
    render: { kind: "plasma", color: "#e040fb", color2: "#40c4ff" } },
  { id: "exp.prism", slot: "explosion", name: "Prism", price: 160,
    render: { kind: "prism", color: "#ffffff" } },
  { id: "exp.void", slot: "explosion", name: "Void", price: 170,
    render: { kind: "void", color: "#1a1a2e", color2: "#7c4dff" } },
  { id: "exp.gold", slot: "explosion", name: "Gold", price: 200,
    render: { kind: "gold", color: "#ffd700", color2: "#fff176" } },

  // --- GOD ---
  { id: "exp.god", slot: "explosion", name: "Judgement", price: 999,
    render: { kind: "divine", color: "#0a0a0a", color2: "#ffd700" } },
  // --- CREATOR (admin-grant only) ---
  { id: "exp.creator", slot: "explosion", name: "Creator Blast", price: 1500,
    render: { kind: "creator", color: "#ffffff" } },
  // --- Monochrome ---
  { id: "exp.mono", slot: "explosion", name: "Monochrome", price: 400,
    render: { kind: "shatter", color: "#bdbdbd", color2: "#f5f5f5" } },
];

const byId = new Map(CATALOG.map((it) => [it.id, it]));
const SLOT_VALUES = new Set(SLOTS);

// The CREATOR collection — one item per slot (incl. day + night skies), plus the
// original banner. Granted and revoked together by the admin "Give/Take CREATOR".
export const CREATOR_IDS = [
  "ban.creator",
  "char.creator",
  "hat.creator",
  "trail.creator",
  "frame.creator",
  "bg.creator_day",
  "bg.creator_night",
  "exp.creator",
];

// The GOD collection — purchasable, gold/divine themed.
export const GOD_IDS = [
  "char.god",
  "ban.god",
  "hat.cross",
  "trail.divine",
  "frame.gates_of_heaven",
  "bg.god_day",
  "bg.god_night",
  "exp.god",
];

// The Monochrome collection — purchasable, black / gray / white themed.
export const MONO_IDS = [
  "char.mono",
  "ban.mono",
  "hat.mono",
  "trail.mono",
  "frame.mono",
  "bg.mono_day",
  "bg.mono_night",
  "exp.mono",
];

// --- Earned collections: unlocked by gameplay milestones, never for sale. ---
// Each definition expands into a full 7-slot themed set, so adding one is a
// one-line change. Ids are `<slot>.<def.id>` (e.g. char.century) and stay stable.

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
function rgbToHex(r, g, b) {
  const c = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, "0");
  return `#${c(r)}${c(g)}${c(b)}`;
}
function lighten(hex, t) {
  const [r, g, b] = hexToRgb(hex);
  return rgbToHex(r + (255 - r) * t, g + (255 - g) * t, b + (255 - b) * t);
}
function darken(hex, t) {
  const [r, g, b] = hexToRgb(hex);
  return rgbToHex(r * (1 - t), g * (1 - t), b * (1 - t));
}

// Per-collection style picks (indexed by position) so each set looks distinct.
const EARNED_FEATURES = ["crest", "spikes", "frill", "halo", "none", "horns", "crest", "spikes", "frill", "halo", "none"];
const EARNED_HATS = ["crown", "top_hat", "fedora", "badge", "helmet", "headphones", "cat_ears", "crown", "top_hat", "fedora", "badge"];
const EARNED_TRAILS = ["star", "sparkle", "fire", "gold", "neon", "plasma", "confetti", "magic", "cosmic", "crystal", "star"];
// All animated frame kinds (they use the collection's color/color2), so every
// earned collection's frame is animated.
const EARNED_FRAMES = ["neon", "cosmic", "flame", "steampunk", "lava", "bubble", "neon", "cosmic", "flame", "steampunk", "lava"];
const EARNED_EXPLOSIONS = ["starburst", "sparkle", "firework", "gold", "nova", "plasma", "confetti", "spiral", "prism", "comet", "starburst"];

// metric "score" = pipes passed in a run; "flies" = flies collected in a run.
const EARNED = [
  { id: "hatchling", name: "Hatchling", metric: "score", goal: 5,   base: "#8bc34a", accent: "#ffeb3b", color: "#aed581" },
  { id: "fledgling", name: "Fledgling", metric: "score", goal: 15,  base: "#26a69a", accent: "#b2dfdb", color: "#4db6ac" },
  { id: "glider",    name: "Glider",    metric: "score", goal: 30,  base: "#42a5f5", accent: "#fff3b0", color: "#64b5f6" },
  { id: "fifty",     name: "50",        metric: "score", goal: 50,  base: "#00c853", accent: "#ffd700", color: "#00e676", label: "50" },
  { id: "ace",       name: "Ace",       metric: "score", goal: 75,  base: "#ab47bc", accent: "#ffd54f", color: "#ba68c8" },
  { id: "century",   name: "Century",   metric: "score", goal: 100, base: "#ff7043", accent: "#ffd700", color: "#ff8a65" },
  { id: "legend",    name: "Legend",    metric: "score", goal: 150, base: "#5c6bc0", accent: "#ffd700", color: "#7986cb" },
  { id: "mythic",    name: "Mythic",    metric: "score", goal: 250, base: "#1a1a2e", accent: "#e040fb", color: "#e040fb" },
  { id: "forager",   name: "Forager",   metric: "flies", goal: 20,  base: "#9ccc65", accent: "#ffd54f", color: "#c5e1a5" },
  { id: "glutton",   name: "Glutton",   metric: "flies", goal: 50,  base: "#ec407a", accent: "#f8bbd0", color: "#f06292" },
  { id: "hoarder",   name: "Hoarder",   metric: "flies", goal: 100, base: "#00bcd4", accent: "#ffd700", color: "#26c6da" },
];

function earnedIds(d) {
  return [
    `char.${d.id}`,
    `ban.${d.id}`,
    `hat.${d.id}`,
    `trail.${d.id}`,
    `frame.${d.id}`,
    `bg.${d.id}_day`,
    `bg.${d.id}_night`,
    `exp.${d.id}`,
  ];
}

function buildEarnedItems(d, i) {
  const { id, name, base, accent } = d;
  return [
    { id: `char.${id}`, slot: "character", name, price: 0,
      render: { kind: "lizard", body: base, belly: lighten(base, 0.55), tail: accent, legs: darken(base, 0.45), eyeWhite: "#ffffff", eyePupil: darken(base, 0.6), feature: EARNED_FEATURES[i] } },
    { id: `ban.${id}`, slot: "banner", name, price: 0,
      render: { kind: "milestone", a: base, b: accent, label: d.label ?? String(d.goal) } },
    { id: `hat.${id}`, slot: "hat", name, price: 0,
      render: { kind: EARNED_HATS[i], primary: accent, secondary: base } },
    { id: `trail.${id}`, slot: "trail", name, price: 0,
      render: { kind: EARNED_TRAILS[i], color: accent, color2: base, sizeMin: 2.5, sizeMax: 4, vy: -12, lifeMin: 0.5, lifeMax: 0.8, ratePerSec: 12 } },
    { id: `frame.${id}`, slot: "frame", name, price: 0,
      render: { kind: EARNED_FRAMES[i], color: base, color2: accent, width: 3 } },
    { id: `bg.${id}_day`, slot: "background", name: `${name} Day`, price: 0,
      render: { kind: "sky", skyTop: lighten(base, 0.4), skyBottom: lighten(base, 0.78), treeFar: darken(base, 0.35), treeNear: darken(base, 0.6), cloud: "rgba(255,255,255,0.85)", sun: accent, isNight: false } },
    { id: `bg.${id}_night`, slot: "background_night", name: `${name} Night`, price: 0,
      render: { kind: "sky", skyTop: darken(base, 0.8), skyBottom: darken(base, 0.55), treeFar: darken(base, 0.86), treeNear: darken(base, 0.92), cloud: "rgba(220,220,255,0.30)", sun: accent, isNight: true } },
    { id: `exp.${id}`, slot: "explosion", name: `${name} Explosion`, price: 0,
      render: { kind: EARNED_EXPLOSIONS[i], color: accent, color2: base } },
  ];
}

// Expand the earned collections into the catalog + lookup map.
for (const it of EARNED.flatMap((d, i) => buildEarnedItems(d, i))) {
  CATALOG.push(it);
  byId.set(it.id, it);
}

// --- CUSTOM collection (admin-grant only) ---
// A single sentinel item whose ownership unlocks the in-game pixel editor. The
// drawings themselves live client-side (localStorage), one per slot; only this
// access flag is server-backed, granted via the normal "Give Collection" flow.
export const CUSTOM_ACCESS_ID = "custom.access";
// Edge length of a custom pixel grid.
export const CUSTOM_GRID_SIZE = 16;
const CUSTOM_ACCESS_ITEM = {
  id: CUSTOM_ACCESS_ID,
  slot: "character",
  name: "Custom Studio",
  price: 0,
  render: { kind: "lizard", body: "#3ad1c8", belly: "#d6fff9", tail: "#1aa79c", legs: "#0e7a72" },
};
CATALOG.push(CUSTOM_ACCESS_ITEM);
byId.set(CUSTOM_ACCESS_ID, CUSTOM_ACCESS_ITEM);

// True for player-drawn item ids. These are never in the catalog (they live
// client-side), so validateItemId/equip on the server reject them by design —
// equipping a custom item is a purely local operation.
export function isCustomItemId(id) {
  return typeof id === "string" && id.startsWith("custom.u.");
}

// Registry used to highlight collection items in the shop and drive the
// Collections screen. `unlock` marks earned collections (others are bought/granted).
export const COLLECTIONS = [
  { id: "god", name: "GOD", color: "#ffd700", ids: GOD_IDS },
  { id: "creator", name: "CREATOR", color: "#ff2fd0", rainbow: true, ids: CREATOR_IDS },
  { id: "custom", name: "CUSTOM", color: "#3ad1c8", ids: [CUSTOM_ACCESS_ID] },
  { id: "mono", name: "Monochrome", color: "#e0e0e0", ids: MONO_IDS },
  ...EARNED.map((d) => ({
    id: d.id,
    name: d.name,
    color: d.color,
    ids: earnedIds(d),
    unlock: { metric: d.metric, goal: d.goal },
  })),
];

const COLLECTION_BY_ID = new Map();
for (const c of COLLECTIONS) for (const id of c.ids) COLLECTION_BY_ID.set(id, c);

export function collectionOf(id) {
  if (typeof id !== "string") return null;
  return COLLECTION_BY_ID.get(id) ?? null;
}

// Items the shop can never sell — CREATOR is admin-grant only; earned sets are
// awarded by passing milestones.
const EARNED_ALL_IDS = EARNED.flatMap(earnedIds);
export const RESTRICTED_IDS = new Set([...CREATOR_IDS, CUSTOM_ACCESS_ID, ...EARNED_ALL_IDS]);

// The earned collections a run qualifies for (idempotent grant uses this).
export function earnedGrantsFor(score, flies) {
  const out = [];
  for (const d of EARNED) {
    const value = d.metric === "flies" ? flies : score;
    if (value >= d.goal) out.push({ name: d.name, ids: earnedIds(d) });
  }
  return out;
}

export function isRestricted(id) {
  return RESTRICTED_IDS.has(id);
}

export function getItem(id) {
  if (typeof id !== "string") return null;
  return byId.get(id) ?? null;
}

export function getBySlot(slot) {
  return CATALOG.filter((it) => it.slot === slot);
}

export function validateItemId(id) {
  return typeof id === "string" && byId.has(id);
}

export function isSlot(slot) {
  return typeof slot === "string" && SLOT_VALUES.has(slot);
}

export function priceOf(id) {
  const it = getItem(id);
  return it ? it.price : null;
}
